import {deviceReachability} from '../../core/deviceReachability';

/**
 * Serialize Switch context for the agent API.
 *
 * Which Switch is on screen is what lets "show the mac table" mean this
 * one. The catalogue declares current_target for eleven Switch
 * capabilities, all keyed on page_context.switch_id - but no serializer
 * contributed that key, so it never left the browser and every one of them
 * asked "Which Switch should I use?" of someone already looking at it.
 *
 * The route is checked the way the Access Point one checks its own: a
 * Switch id left over in the registry must not travel from a page that is
 * not a Switch Dashboard.
 *
 * @param {object} context mounted page context
 * @return {object} public Switch context
 */
export function serializeSwitchContext(context) {
	const route = context.route?.toLowerCase();
	const hasSwitchContext = route === '/switch-detail';
	const switchId = context.switch_id ?? context.switchId;
	const switchName = context.switch_name ?? context.switchName;
	return {
		...deviceReachability(hasSwitchContext, context.target_online),
		switch_id: hasSwitchContext &&
			typeof switchId === 'string' &&
			switchId
			? switchId
			: null,
		switch_name: hasSwitchContext &&
			typeof switchName === 'string' &&
			switchName
			? switchName
			: null,
	};
}
